export const ENDPOINTS = {
  LEARNING: {
    MANAGE: {
      BASE: '/learning/manage',
      RESOURCES: '/learning/manage/resources',
      RESOURCE: '/learning/manage/resource',
      SPECIALISMS: '/learning/manage/specialisms',
      SPECIALISM: '/learning/manage/specialism',
      ROLE_PROFILE: '/learning/manage/role/profiles',
    },
    QUIZ_SESSION: {
      BASE: '/learning/quiz-session',
      HISTORY: '/learning/quiz-session/history',
      PROFILE: '/learning/quiz-session/profile',
      RESET: '/learning/quiz-session/reset',
    },
    RESOURCE: {
      BASE: '/learning/resource',
      PAGINATED: '/learning/resources-paginated',
      SEARCH: '/learning/resource-search',
      FACETS: '/learning/resource/facets',
      RECOMMENDATIONS: '/learning/resource/recommendations',
      INTERACTION: '/learning/resource/user-interaction',
      EMAIL_MANAGER: '/learning/resource/emailManager',
    },
    ROLE: {
      PROFILE: '/learning/role/profile',
      DEPARTMENTS: '/learning/role/departments',
    },
    SKILL: {
      CATEGORY: '/learning/skill-category',
      GROUP: '/learning/skill-group',
      ASSESSMENT: '/learning/skill-category/assessment',
    },
    SPECIALISM: {
      BASE: '/learning/specialisms',
    },
  },
  USER: {
    PROFILE: '/user/staff/profile',
  },
};
